import { render, staticRenderFns } from "./VariableSetter.vue?vue&type=template&id=2524f653"
import script from "./VariableSetter.vue?vue&type=script&lang=js"
export * from "./VariableSetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports